
import {useEffect, useRef, useState} from 'react'
import './LeftMenuFileItem.scss'
import {ActionType} from "../../../store/actionTypes";
import {useTypedSelector} from "../../../hooks/useTypeSelector";

interface ILeftMenuFileItem {
    imageSrc: string,
    title: string,
    isForDownloading: boolean,
    onFileSelected?: (file: File) => void,
    withInputInfo?: boolean
}

export const LeftMenuFileItem: React.FC<ILeftMenuFileItem> = (props) => {
    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);

    const inputRef:React.LegacyRef<HTMLInputElement> = useRef(null);

    const [fileNameData, setFileName] = useState<{ fileName: string, afterRequest: string }>({
        fileName: '',
        afterRequest: ''
    });


    useEffect(() => {
        if(flippingFlyerState.type === ActionType.POST_FLYER_PROMOS_AND_ITEMS_SUCCESS
            || flippingFlyerState.type === ActionType.POST_IMAGES_FOR_PROMOTIONS_ITEMS_SUCCESS){
            setFileName({
                ...fileNameData,
                afterRequest: fileNameData.fileName
            })

        }

    }, [flippingFlyerState.type])


    const onClick = () => {
        if(props.isForDownloading){
            return;
        }

        inputRef.current?.click();
    }

    const onFileSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];
        setFileName({
            ...fileNameData,
            fileName: file.name
        })
        props.onFileSelected!(file)
    }

    return (
        <div className="spots_file_item_container">
            <div>
                <img src={props.imageSrc} onClick={onClick}/>
                <p>{props.title}</p>

                <input
                    ref={inputRef}

                    // must be hidden
                    hidden

                    type="file"
                    accept={".xls,.xlsx"}

                    multiple={false}
                    onClick={(e) => {
                        //--------------------------------------------------//
                        // BUG FIX: to select the same file multiple times

                        // bug fix: for chrome
                        if( inputRef.current !== null){
                            inputRef.current!.value = '';
                        }
                        // bug fix: for firefox
                        return false;
                        //--------------------------------------------------//
                    }}
                    onChange={onFileSelected}
                />

            </div>
            {props.withInputInfo && <input type='text' readOnly={true} className="info_input" value={fileNameData.afterRequest}/>}
        </div>
    )
}